import { UserProject } from '@teachur/http-client';
import ApiService from './apiService';

const ProjectService = {
  getUserProject: async (userProjectId: number) => {
    const response = await ApiService.get(`/user-projects/${userProjectId}`);
    return response.data;
  },

  updateProjectReview: async (
    userProjectId: number,
    data: {
      grades: UserProjectGrade[];
      userProject: UserProject;
    }
  ) => {
    const response = await ApiService.put(`/user-projects/${userProjectId}/review`, data);
    return response.data as UserProject;
  },

  getAllUserProjectsForProject: async (userId: number, projectId: number) => {
    const response = await ApiService.get(`/users/${userId}/project/${projectId}`);
    return response.data as UserProject[];
  },
  deleteFileProject: async (projectId: number, fileId: number): Promise<User> => {
    const response = await ApiService.delete(`/user-projects/${projectId}/file/${fileId}`);
    return response.data;
  },
};

export default ProjectService;
